import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library

// Initialize AOS with your desired configuration
AOS.init({
  duration: 800, // Animation duration in milliseconds
  easing: 'ease-in-out', // Easing type
  once: false, // Whether animation should only happen once
  disable: window.matchMedia("(prefers-reduced-motion: reduce)").matches // Disable animation if prefers-reduced-motion is set
});
